module.exports = __webpack_public_path__ + "img/sankaku_96_red.42f61642.png";